import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskNotificationsRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-notifications',
	path: '/jira/servicedesk/projects/:projectKey/settings/notifications',
	exact: true,
};
